import config from '../config';

export const { REACT_APP_INTERNAL_APP_URL } = config;
export const BRANDBAR_HEIGHT = '56px';
export const SIDEBAR_WIDTH = '208px';

export const isProd = config.ENVIRONMENT === 'production';
